/* eslint-disable */

import React, { Component } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: auto !important;
`;

class InputGroupComponent extends Component {
  render() {
    const {
      placeholder,
      actionText,
      value,
      action,
      onChange,
      onAction,
      loading
    } = this.props;
    return (
      <Container className="ui left action  loading icon input">
        <button className="ui button left" role="button" onClick={onAction}>
          {actionText}
        </button>
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
        {loading && <i aria-hidden="true" className="spinner icon" />}
      </Container>
    );
  }
}

export default InputGroupComponent;



// WEBPACK FOOTER //
// ./src/components/share/InputGroup.js